import { IconProps } from './interfaces';

export const IconNotificationOutline = ({ className }: IconProps) => {
    return (
        <svg className={className} width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <g id="Info">
                <g id="Shape">
                    <path d="M12 9.46484C12.5523 9.46484 13 9.01713 13 8.46484C13 7.91256 12.5523 7.46484 12 7.46484C11.4477 7.46484 11 7.91256 11 8.46484C11 9.01713 11.4477 9.46484 12 9.46484Z" />
                    <path d="M13 11.5C13 10.9477 12.5523 10.5 12 10.5C11.4477 10.5 11 10.9477 11 11.5V16.4902C11 17.0425 11.4477 17.4902 12 17.4902C12.5523 17.4902 13 17.0425 13 16.4902V11.5Z" />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M22 12.5C22 18.0228 17.5228 22.5 12 22.5C6.47715 22.5 2 18.0228 2 12.5C2 6.97715 6.47715 2.5 12 2.5C17.5228 2.5 22 6.97715 22 12.5ZM12 20.5C16.4183 20.5 20 16.9183 20 12.5C20 8.08172 16.4183 4.5 12 4.5C7.58172 4.5 4 8.08172 4 12.5C4 16.9183 7.58172 20.5 12 20.5Z"
                    />
                </g>
            </g>
        </svg>
    );
};
